import React from 'react';
import { Box } from './box';
export const HR = ({ bg = 'borders', my = 'l', orientation = 'horizontal', ...rest }) => {
    const height = orientation === 'vertical' ? '100%' : '1px';
    const width = orientation === 'vertical' ? '1px' : 'auto';
    return React.createElement(Box, Object.assign({ bg: bg, my: my, height: height, width: width }, rest));
};
//# sourceMappingURL=separators.js.map